import React from "react";
import AudioClipLibrary from "@/components/audio/AudioClipLibrary";
import { AudioLibrary } from "@/enum/AudioLibrary";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function VoicemailMessagesTab() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Voicemail Messages</CardTitle>
        <CardDescription>
          Messages the power dialer drops on voicemail boxes and plays to late answers. They only go to numbers with
          written call consent where the state allows recorded messages.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <AudioClipLibrary category={AudioLibrary.VOICEMAIL_MESSAGE} />
      </CardContent>
    </Card>
  );
}
